<template>
  <div>
    <div class="row pb-3">
      <div class="col-sm-12">
        <h4 class="font-weight-bold">
          Histórico de participações no Serviço de Convivência e Fortalecimento de
          Vínculos
        </h4>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table">
          <thead>
            <th>Detalhes</th>
            <th>Vínculado</th>
            <th>Status</th>
          </thead>

          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>
                Nome do Grupo: {{ item.scfv_grupo?.nome_grupo || '-' }}<br />
                Situação Prioritária:
                <span v-html="item.situacao_prioritaria_nome || '-'"></span>
              </td>

              <td>{{ item.cadastrado || '-' }}</td>

              <td>{{ item.status_nome || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items"],
};
</script>